import PointListCell from '@components/Home/Dashboard/variants/PointListCell';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { IDashboardCell } from '@src/types/SiteMetaUI';
import React, { ReactElement } from 'react';
import './DashboardCell.scoped.scss';
import FormattedAlias from '@components/_shared/Translations/FormattedAlias';

interface DashboardCellProps {
  variant: 'points-list';
  data: IDashboardCell['data'];
}

function DashboardCell({ variant, data }: DashboardCellProps) {
  const renderCell = (component: ReactElement) => (
    <div
      className={`dashboard-cell-container${data.title ? ' with-title' : ''}`}
    >
      <div className='drag-handle'>
        <DragIndicatorIcon />
      </div>
      {data.title ? (
        <div className='cell-title'>
          <h5 className='bold'>
            <FormattedAlias id={data.title} />
          </h5>
        </div>
      ) : null}
      {component}
    </div>
  );

  switch (variant) {
    case 'points-list':
      return renderCell(<PointListCell data={data} />);
    default:
  }
}

export default React.memo(DashboardCell);
